import { Link } from "react-router-dom";

export default function BrandComponent({ bgColor, light }) {
  return (
    <>
      <section id="blog" className={`our-blog-section ptb-100 ${bgColor}`}>
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="section-heading mb-5">
                <h2 className={`${light ? "text-black" : "text-white"}`}>
                  Recursos de Marca
                </h2>
                <p className="lead">
                  Te mostraremos como se usa nuestra marca y como la podes aplicar en tu dia a dia.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="single-blog-card card border-0 shadow-sm">
                <span className="category position-absolute badge badge-pill badge-primary">
                  Logo
                </span>
                <img
                  src="assets/img/logo-white-1x.png"
                  className="card-img-top position-relative"
                  alt="blog"
                />
                <div className="card-body">
                  <h3 className="h5 card-title">
                    <Link to="/">
                      Uso del logo. 
                    </Link>
                  </h3>
                  <p className="card-text text-dark">
                  ¿Desea descargar el logotipo de Hotmy? Los archivos de ilustraciones para impresión (.EPS), transmisión y web (.SVG y .PNG) se pueden descargar desde aquí.
                  Para un uso adecuado, consulte la sección Logotipo en nuestras Directrices de marca.
                  </p>
                  <Link to="/" className="detail-link">
                    Descargar Recurso <span className="ti-arrow-right"></span>
                  </Link>
                </div>
              </div>
            </div>
            {/* <div className="col-md-4">
              <div className="single-blog-card card border-0 shadow-sm">
                <span className="category position-absolute badge badge-pill badge-danger">
                  Technology
                </span>
                <img
                  src="assets/img/blog/2.jpg"
                  className="card-img-top position-relative"
                  alt="blog"
                />
                <div className="card-body">
                  <div className="post-meta mb-2">
                    <ul className="list-inline meta-list">
                      <li className="list-inline-item">May 26, 2019</li>
                      <li className="list-inline-item">
                        <span>30</span> Comments
                      </li>
                      <li className="list-inline-item">
                        <span>5</span> Share
                      </li>
                    </ul>
                  </div>
                  <h3 className="h5 card-title">
                    <Link to="/blog-details">Quickly formulate backend</Link>
                  </h3>
                  <p className="card-text text-dark">
                    Synergistically engage effective ROI after customer directed
                    partnerships.
                  </p>
                  <Link to="/blog-details" className="detail-link">
                    Read more <span className="ti-arrow-right"></span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="single-blog-card card border-0 shadow-sm">
                <span className="category position-absolute badge badge-pill badge-info">
                  Science
                </span>
                <img
                  src="assets/img/blog/3.jpg"
                  className="card-img-top"
                  alt="blog"
                />
                <div className="card-body">
                  <div className="post-meta mb-2">
                    <ul className="list-inline meta-list">
                      <li className="list-inline-item">Apr 25, 2019</li>
                      <li className="list-inline-item">
                        <span>41</span> Comments
                      </li>
                      <li className="list-inline-item">
                        <span>30</span> Share
                      </li>
                    </ul>
                  </div>
                  <h3 className="h5 card-title">
                    <Link to="/blog-details">Objectively extend extensive</Link>
                  </h3>
                  <p className="card-text text-dark">
                    Holisticly mesh open-source leadership rather than proactive
                    users.
                  </p>
                  <Link to="/blog-details" className="detail-link">
                    Read more <span className="ti-arrow-right"></span>
                  </Link>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}
